/**
 * @generated SignedSource<<51489107fd2ea422488254b3256407f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateClientPortalConfigInput = {
  clientOrgId: string;
  clientName?: string | null;
  portalActive?: boolean | null;
  accountManagerId?: string | null;
  portalPrimaryColour?: string | null;
  portalSenderName?: string | null;
  showInvoices?: boolean | null;
  allowFileUpload?: boolean | null;
  showRetainer?: boolean | null;
  hideTimeEntries?: boolean | null;
  hideEstimates?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateClientPortalConfigMutation$variables = {
  input: UpdateClientPortalConfigInput;
};
export type updateClientPortalConfigMutation$data = {
  readonly updateClientPortalConfig: {
    readonly clientPortalConfig: {
      readonly portalActive: boolean | null;
      readonly portalLogoUrl: string | null;
      readonly portalPrimaryColour: string | null;
      readonly portalSenderName: string | null;
      readonly showInvoices: boolean | null;
      readonly allowFileUpload: boolean | null;
      readonly showRetainer: boolean | null;
      readonly hideTimeEntries: boolean | null;
      readonly hideEstimates: boolean | null;
    } | null;
  } | null;
};
export type updateClientPortalConfigMutation = {
  variables: updateClientPortalConfigMutation$variables;
  response: updateClientPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateClientPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateClientPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientPortalConfig",
        "kind": "LinkedField",
        "name": "clientPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalLogoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalPrimaryColour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalSenderName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showInvoices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowFileUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showRetainer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideTimeEntries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideEstimates",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateClientPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateClientPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc90d41b7421d6021bcd622daeca4e60",
    "id": null,
    "metadata": {},
    "name": "updateClientPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateClientPortalConfigMutation(\n  $input: UpdateClientPortalConfigInput!\n) {\n  updateClientPortalConfig(input: $input) {\n    clientPortalConfig {\n      portalActive\n      portalLogoUrl\n      portalPrimaryColour\n      portalSenderName\n      showInvoices\n      allowFileUpload\n      showRetainer\n      hideTimeEntries\n      hideEstimates\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbf72ee26deb4d1fdcfa2e5462e28ac1";

export default node;
